import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'bgoCompanyInitials',
})
export class CompanyInitialsPipe implements PipeTransform {
  transform(companyName: string): string {
    if (!companyName.length) return ''
    return companyName
      .split(/\s/g)
      .filter(word => word.length > 0) // two spaces in a row would yield an empty word, remove these
      .map(word => word[0].toUpperCase()) // get first letter of each word
      .join('. ') // separate letters with a dot and space
  }
}
